// Slice 04e — ONE escape for app data interpolated into HTML, for the whole app.
// PURE: no React/DOM/network, so the recording harness imports the same code the
// browser runs.
//
// WHY IT EXISTS
//   Before 04e this function existed twice, hand-rolled, and the two disagreed.
//   `bulkMailAssembly.js` had `htmlEscape` (all five characters); the chat
//   pop-out had one that handled `& < >` only, and 04d fixed it in place by
//   adding the quotes — because its output lands inside a double-quoted
//   `title="…"` attribute and a collaborator whose name held a `"` could break
//   out of it. A third copy would have settled the pattern in the wrong
//   direction, so there is now one authority and this is it.
//
// THE FIVE, and why all five
//   & < > " '  — the output lands in element content AND inside double-quoted
//   attributes, and escaping only the angle brackets is precisely the defect
//   04d found in the pop-out. `'` is escaped as the numeric `&#39;` rather than
//   `&apos;`, which is not defined in HTML4 and is the safer of the two.
//
// WHAT IT IS NOT FOR
//   The TEMPLATE, ever. A bulk-mail template and the firm footer are raw HTML
//   BY DESIGN — escaping those would ship `&lt;p&gt;` to clients. This escapes
//   the VALUES that get interpolated into a template, and nothing else. See
//   `bulkMailMerge.js` renderTemplate for the call site where that distinction
//   is the whole point.

// One pass, not five chained replaces. The chained form is order-dependent —
// it works only because `&` is replaced FIRST, so the `&` it introduces into
// `&lt;` is not re-escaped by a later pass. That is a correctness argument a
// reader has to reconstruct; a single pass has none to make, because `replace`
// never rescans what it has written. The recording asserts the two agree over
// every input, so this is proven equivalent rather than merely believed to be.
const HTML_ESCAPE_RE = /[&<>"']/g;
const HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

// null/undefined → "" (not the strings "null"/"undefined"). Both prior copies
// did this and every call site depends on it: a merge token for a client with
// no company name must render blank, not the word "null".
export function escapeHtml(v) {
  return String(v == null ? "" : v).replace(HTML_ESCAPE_RE, (ch) => HTML_ESCAPES[ch]);
}

export { HTML_ESCAPES };
